import { useState, useEffect } from 'react';
import { adminApi } from '../../api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Users, Package, ShoppingBag, Wallet, MessageSquare, TrendingUp, Loader2 } from 'lucide-react';

const formatMoney = (amount) => new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN', minimumFractionDigits: 0 }).format(amount);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => { fetchStats(); }, []);

  const fetchStats = async () => {
    try { const response = await adminApi.getStats(); setStats(response.data); } 
    catch (error) { console.error('Failed to fetch stats:', error); } 
    finally { setIsLoading(false); }
  };

  if (isLoading) return <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-[#FFD700]" /></div>;

  const statCards = [
    { title: 'Total Users', value: stats?.total_users || 0, icon: Users, color: 'text-blue-500' },
    { title: 'Total Products', value: stats?.total_products || 0, icon: Package, color: 'text-green-500' },
    { title: 'Total Orders', value: stats?.total_orders || 0, icon: ShoppingBag, color: 'text-purple-500' },
    { title: 'Pending Deposits', value: stats?.pending_deposits || 0, icon: Wallet, color: 'text-yellow-500' },
    { title: 'Open Disputes', value: stats?.open_disputes || 0, icon: MessageSquare, color: 'text-red-500' },
    { title: 'Total Revenue', value: formatMoney(stats?.total_revenue || 0), icon: TrendingUp, color: 'text-[#FFD700]' },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white font-['Outfit']">Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {statCards.map((stat, index) => (
          <Card key={index} className="bg-[#0A0A0A] border-white/10">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div><p className="text-sm text-zinc-500">{stat.title}</p><p className="text-2xl font-bold text-white mt-1">{stat.value}</p></div>
                <div className={`w-12 h-12 rounded-lg bg-white/5 flex items-center justify-center ${stat.color}`}><stat.icon className="w-6 h-6" /></div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
